import $ from 'jquery';
import Swiper, {Navigation, Pagination} from 'swiper';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');
Swiper.use([Navigation, Pagination]);


/**
 * Swiper
 */
$('.swiper').each(function () {

    if (inBackend) return;

    const $element = $(this);

    const $slides = $element.find('.swiper-slide');
    if ($slides.length < 2) {
        return;
    }

    new Swiper($element[0], {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        // autoHeight: true,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});
